import { LayoutType, withLayout } from 'hocs/with-layout';
import { withAuth } from 'hocs/auth/with-auth';
import { Store } from './store';

const WrappedPage = withAuth(Store);
const WrappedAccountView = withLayout(LayoutType.WithOldNavOnly, WrappedPage);

export { WrappedAccountView as Store };
